import {memo, useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import FormSelect, {formSelectSizes} from '@adv-mt/mt-form-select'
import FormSelectToggle from '@adv-mt/mt-form-select-toggle'

const LEGACY_WRAPPER = 'legacy'

const FormVehicleState = ({
  isSelectToggle = false,
  onChange,
  overlayContentRef,
  type,
  value,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {DEFAULT_VEHICLE_STATE, FILTER_NAMES} = config.get('search')
  const {vehicleStates} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const currentValue = value || DEFAULT_VEHICLE_STATE

  const FIRST_OPTION = isSelectToggle
    ? {
        literal: i18n.t('COMMON.ALL'),
        value: DEFAULT_VEHICLE_STATE
      }
    : {label: i18n.t('COMMON.ALL'), id: allSelectionsId}

  const vehicleStateOptions = useMemo(
    () =>
      vehicleStates.map(({id, label}) =>
        isSelectToggle && wrapper === LEGACY_WRAPPER
          ? {
              literal: label,
              value: id
            }
          : {
              id,
              label: i18n.t(label)
            }
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const options = [FIRST_OPTION, ...vehicleStateOptions]

  const _handleChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.VEHICLE_STATE,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.VEHICLE_STATE],
      value
    })
  }

  const handleChange = ({value: selectedValue}) => {
    const [firstValue] = selectedValue
    _handleChange(null, {value: firstValue})
  }

  if (wrapper === LEGACY_WRAPPER) {
    return isSelectToggle ? (
      <FormSelectToggle
        label={i18n.t('COMMON.VEHICLE_STATE')}
        onChange={_handleChange}
        options={options}
        value={currentValue}
      />
    ) : (
      <FormSelect
        label={i18n.t('COMMON.VEHICLE_STATE')}
        onChange={_handleChange}
        options={options}
        size={formSelectSizes.LARGE}
        value={currentValue}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          name: FILTER_NAMES.VEHICLE_STATE,
          options,
          type
        }
      ]}
      group={`${FILTER_NAMES.VEHICLE_STATE}Group`}
      label={withLabel && i18n.t('COMMON.VEHICLE_STATE')}
      onChange={({value}) => {
        handleChange({value: value.filter(id => id !== allSelectionsId)})
      }}
      overlayContentRef={overlayContentRef}
      placeholder={value ? options.find(({id}) => id === value)?.label : i18n.t('COMMON.ALL')}
      value={{[FILTER_NAMES.VEHICLE_STATE]: [value || allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormVehicleState.displayName = 'FormVehicleState'
FormVehicleState.propTypes = {
  isSelectToggle: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  type: PropTypes.string,
  value: PropTypes.number,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

const FormVehicleStateSelectToggle = props => <FormVehicleState {...props} />
FormVehicleStateSelectToggle.displayName = 'FormVehicleStateSelectToggle'

const FormVehicleStateSelectMemo = memo(FormVehicleState)
FormVehicleStateSelectMemo.displayName = 'FormVehicleStateSelectMemo'

const FormVehicleStateSelectToggleMemo = memo(FormVehicleStateSelectToggle)
FormVehicleStateSelectToggleMemo.displayName = 'FormVehicleStateSelectToggleMemo'

export {
  FormVehicleStateSelectMemo as FormVehicleStateSelect,
  FormVehicleStateSelectToggleMemo as FormVehicleStateSelectToggle
}

export default memo(FormVehicleState)
